<template>
    <button
        :tabindex="tabindex"
        @click="$emit('click')"
        type="button"
        aria-label="close"
        :class="[
            'flex items-center',
            // 'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
        ]"
    >
        <img
            v-if="variant === 'white'"
            src="../../assets/images/icons/close-white-48dp.svg"
            :width="width"
            :height="width"
            alt="X"
            :class="`w-[${width}px] h-[auto]`"
        />
        <img
            v-else
            src="../../assets/images/icons/close-48dp.svg"
            :width="width"
            :height="width"
            alt="X"
            :class="`w-[${width}px] h-[auto]`"
        >
    </button>
</template>

<script>
    export default {
        name: 'CloseButton',
        variants: ['black', 'white'],
        props: {
            variant: {
                type: String,
                default: 'black',
            },
            width: {
                type: String,
                default: '16',
            },
            tabindex: {
                type: String,
                default: '0',
            },
        },
    };
</script>